import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center border transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground border-solid",
        success: "text-utility-success-700 border-success-200 bg-success-50",
        warning: "text-utility-warning-700 border-warning-200 bg-warning-50",
        error: "text-utility-error-700 border-error-200 bg-error-50",
        brand: "text-utility-brand-700 border-utility-brand-200 bg-utility-brand-50",
      },
      size: {
        legacy: "rounded-full px-2.5 py-0.5 text-xs-semibold",
        sm: "text-xs-medium px-sm py-xxs rounded-md border-solid whitespace-nowrap [&>svg]:size-3",
        md: "text-sm-medium px-md py-xs rounded-md border-solid whitespace-nowrap [&>svg]:size-3.5",
        lg: "text-sm-medium px-lg py-sm rounded-md border-solid whitespace-nowrap [&>svg]:size-4",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "legacy",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
